<template>
  <div class="animated fadeIn">
    <b-row>
      <div class="print-button-container">
        <b-button
          type="button"
          variant="outline-primary"
          size="lg"
          @click="printForm"
        >
          <span class="button-text">Print Form</span>
        </b-button>
      </div>
    </b-row>
    <b-row>
      <b-col sm="12">
        <h3> Commercial Sexual Exploitation Identification Tool (CSE-IT)</h3>
        <br>
        <p> Below is a summary of your responses </p>
        <br>
        <p><b>Agency/Program: </b>{{cseit.organizationCreator.title}} </p>
        <p><b>Youth Code: </b>{{cseit.person.id}} </p>
        <p><b>CSE-IT Code: </b> {{cseit.id}} </p>
        <p><b>Youth's Age: </b> {{calculateAge(cseit.createdAt, cseit.person.b_birthdate)}}</p>
        <p><b>Youth's Gender Identity: </b>{{cseit.person.b_gender_identity}} </p>
        <p><b>Youth's Race/Ethnicity: </b>{{cseit.person.b_race}} </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>1. HOUSING AND CAREGIVING.The youth experiences housing or caregiving instability for any reason.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q1)"><strong>{{cseit.calc_q1}} ({{calculateSummaryNumber(cseit.calc_q1)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('1')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation).</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q2)"><strong>{{cseit.calc_q2}} ({{calculateSummaryNumber(cseit.calc_q2)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('2')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>3. PHYSICAL HEALTH AND APPEARANCE.  The youth experiences notable changes in health and appearance.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q3)"><strong>{{cseit.calc_q3}} ({{calculateSummaryNumber(cseit.calc_q3)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('3')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>4. ENVIRONMENT AND EXPOSURE. The youth's environment and activities place them at risk for exploitation.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q4)"><strong>{{cseit.calc_q4}} ({{calculateSummaryNumber(cseit.calc_q4)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('4')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and personal belongings are not consistent with their age or circumstances, suggesting possible recruitment.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q5)"><strong>{{cseit.calc_q5}} ({{calculateSummaryNumber(cseit.calc_q5)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('5')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs that may result from exposure to any trauma.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q6)"><strong>{{cseit.calc_q6}} ({{calculateSummaryNumber(cseit.calc_q6)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('6')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>7. COERCION. The youth is being controlled or coerced by another person.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q7)"><strong>{{cseit.calc_q7}} ({{calculateSummaryNumber(cseit.calc_q7)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('7')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
      </table>
      <table cellspacing=0 class="cseit-table table table-bordered">
        <tbody>
          <tr>
            <td scope="col"><strong>8. EXPLOITATION. The youth exchanges sex for money or material goods, including food or shelter.</strong></td>
            <td scope="col" v-bind:class="calculationClass(cseit.calc_q8)"><strong>{{cseit.calc_q8}} ({{calculateSummaryNumberEight(cseit.calc_q8)}})</strong></td>
          </tr>
          <tr v-for="(question, index) in filterQuestions('8')">
            <td scope="col">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
            <td>{{questionAnswers[question.id]}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td><h5><strong>CSE-IT Score:</strong></h5></td>
            <td v-bind:class="calculationClass(cseit.calc_cseitScore)"><h5><strong>{{cseit.calc_cseitScore}} ({{cseitFinalScore}})</strong></h5></td>
          </tr>
        </tfoot>
      </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <img src="static/img/cseit_scale.svg" height="75" />
        <p class="introduction-text"><b>Post-CSE-IT Assessment</b></p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <p>Based on your professional judgment and the information available to you at the time of this CSE-IT, <i>including information not assessed on the CSE-IT, </i>do you believe the youth is being, or has been, commercially sexually exploited? </p>
        <h5><b>{{cseit.judge_after}}</b></h5>
        <br/>
        <h5>{{cseit.judge_whynot}}</h5>
        <h5 v-if="cseit.can_duration"><b>Duration</b> </h5>
        <h5 v-if="cseit.can_duration">{{capitalize(cseit.can_duration)}}</h5>
        <h5 v-if="cseit.can_onset"><b>Onset</b> </h5>
        <h5 v-if="cseit.can_onset">{{capitalize(cseit.can_onset)}}</h5>
        <h5 v-if="cseit.can_perception"><b>Perception</b> </h5>
        <h5 v-if="cseit.can_perception">{{capitalize(cseit.can_perception)}}</h5>
        <!-- <h5 v-if="cseit.can_duration">{{capitalize(cseit.can_duration)}}</h5>
=        <h5 v-if="cseit.can_onset">{{capitalize(cseit.can_onset)}}</h5>
        <h5 v-if="cseit.can_perception">{{capitalize(cseit.can_perception)}}</h5>  -->
        <h5 v-if="cseit.comments"><b>Comments</b> </h5>
        <h5 v-if="cseit.comments">{{cseit.comments}}</h5>
        <br>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <p><b>Location: </b>{{getLocationTitle(cseit.cseit_location)}}</p>
        <p><b>Program: </b>{{getProgramTitle(cseit.cseit_program)}}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <p><b>Email: </b>{{cseit.createdBy.emailAddress}}</p>
      </b-col>
    </b-row>

    <!-- Next Steps (TX and Clear Concern only) -->
    <b-row v-if='isUserInTX && cseit.calc_cseitScore === "Clear Concern"'>
      <b-col sm="12">
        <h5 class="pt-4"><b>Next Steps</b></h5>
        <p>Refer the youth for appropriate services, which may include:</p>
        <ul>
          <li><b>Care Coordination</b>, and/or</li>
          <li><b>Commercially Sexually Exploited Youth (CSEY) Advocacy</b></li>
        </ul>
        <p>You may visit the <a href='http://gov.texas.gov/cstt' target='_blank'>Office of the Governor Child Sex Trafficking Team website</a> to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: <a href='mailto:cstt@gov.texas.gov'>cstt@gov.texas.gov</a></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import userStateMixin from '@/mixins/userState.js'

export default {
  name: 'cseit',
  mixins: [userStateMixin],
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      cseit: 'getViewCseit',
      cseitQuestions: 'getCseitQuestions',
      initialFields: 'getInitialFields',
      orgLocations: 'getLocationsByOrg',
      orgPrograms: 'getProgramsByOrg'
    })
  },
  methods: {
    capitalize: function (word) {
      return word.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
    },
    printForm () {
      try {
        if (!document.execCommand('print', false, null)) {
          throw new Error('execCommand not supported')
        }
      } catch (e) {
        console.log(e)
        window.print()
      }
    },
    filterQuestions: function (questionNumber) {
      return this.questions.filter(function (question) {
        return question.order.split('.')[0] === questionNumber
      })
    },
    populateRecords: function () {
      const friendlyCseitId = this.$route.params.id
      const primaryCseitId = this.$route.query.id

      this.$store.dispatch('getCseit', {
        id: friendlyCseitId,
        _id: primaryCseitId
      }).then(response => {
        this.$store.dispatch('getLocationsByOrg', { orgId: this.cseit.organizationCreator.id })
        this.$store.dispatch('getProgramsByOrg', { orgId: this.cseit.organizationCreator.id })
      })

      this.$store.dispatch('getCseitQuestions')
    },
    calculateAge: function (cseitdts, birthdate) {
      let ageText = ''
      if (birthdate === '' || birthdate === '0000-00-00 00:00:00') {
        ageText = 'Not Specified'
      } else {
        let createdDate = new Date(moment.unix(cseitdts / 1000).format('MM/DD/YYYY'))
        let startDate = new Date(birthdate)
        let ageYears = Math.floor((createdDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24 * 365.25))
        ageText = ageYears.toString()
        // let ageYears = Math.floor(($moment.unix(cseitdts / 1000).format("MM/DD/YYYY") - birthdate) / 365.25)
        // ageText = ageYears.toString()
      }
      return ageText
    },
    calculationClass: function (name) {
      if (name === 'Clear Concern') {
        return 'text-danger'
      } else if (name === 'Possible Concern') {
        return 'text-warning'
      } else {
        return ''
      }
    },
    calculateSummaryNumber: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 1
      } else {
        return 2
      }
    },
    calculateSummaryNumberEight: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 4
      } else {
        return 9
      }
    },
    getLocationTitle: function (locationId) {
      const location = this.locations.find((org) => {
        return org.value === Number(locationId)
      })
      return location ? location.text : ''
    },
    getProgramTitle: function (programId) {
      const program = this.programs.find((org) => {
        return org.value === Number(programId)
      })
      return program ? program.text : ''
    }
  },
  data: function () {
    return {
      questions: [],
      questionAnswers: [],
      questionOneNoInformationPercentage: 0,
      questionTwoNoInformationPercentage: 0,
      questionThreeNoInformationPercentage: 0,
      questionFourNoInformationPercentage: 0,
      questionFiveNoInformationPercentage: 0,
      questionSixNoInformationPercentage: 0,
      questionSevenNoInformationPercentage: 0,
      questionEightNoInformationPercentage: 0,
      cseitFinalScore: 0,
      locations: [],
      programs: []
    }
  },
  watch: {
    cseitQuestions: function (newValue) {
      if (newValue) {
        this.questions = Object.assign([], newValue)

        this.questions.sort(function (a, b) {
          if (a.order.split('.')[0] > b.order.split('.')[0]) {
            return 1
          } else if (a.order.split('.')[0] < b.order.split('.')[0]) {
            return -1
          } else {
            if (a.order.split('.')[1] > b.order.split('.')[1]) {
              return 1
            } else if (a.order.split('.')[1] < b.order.split('.')[1]) {
              return -1
            } else {
              return 0
            }
          }
        })
      }
    },
    cseit: {
      handler (newValue) {
        if (newValue) {
          if (this.cseit.judge_after) {
            const judgeAfter = this.initialFields.find(i => i.value === this.cseit.judge_after)
            if (judgeAfter && judgeAfter.label) {
              this.cseit.judge_after = judgeAfter.label
            }
          } else {
            this.cseit.judge_after = 'No Response'
          }

          const judgeBefore = this.initialFields.find(i => i.value === this.cseit.judge_before)
          if (judgeBefore && judgeBefore.label) {
            this.cseit.judge_before = judgeBefore.label
          }

          let i = 0

          let questionOneTotal = 0
          let questionOneNoInformation = 0
          let questionTwoTotal = 0
          let questionTwoNoInformation = 0
          let questionThreeTotal = 0
          let questionThreeNoInformation = 0
          let questionFourTotal = 0
          let questionFourNoInformation = 0
          let questionFiveTotal = 0
          let questionFiveNoInformation = 0
          let questionSixTotal = 0
          let questionSixNoInformation = 0
          let questionSevenTotal = 0
          let questionSevenNoInformation = 0
          let questionEightTotal = 0
          let questionEightNoInformation = 0

          for (let question of this.questions) {
            if (this.questions[i]) {
              let fieldName = question.fieldName
              switch (fieldName) {
                case 'one_a_running':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_a_running
                  if (this.cseit.one_a_running === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_b_housing':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_b_housing
                  if (this.cseit.one_b_housing === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_c_homeless':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_c_homeless
                  if (this.cseit.one_c_homeless === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_d_services':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_d_services
                  if (this.cseit.one_d_services === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_e_supervision':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_e_supervision
                  if (this.cseit.one_e_supervision === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_f_school':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_f_school
                  if (this.cseit.one_f_school === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_g_cps':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_g_cps
                  if (this.cseit.one_g_cps === 'No Information') { questionOneNoInformation++ }
                  break
                case 'two_a_secabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_a_secabuse
                  if (this.cseit.two_a_secabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_b_physicalabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_b_physicalabuse
                  if (this.cseit.two_b_physicalabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_c_emotionalabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_c_emotionalabuse
                  if (this.cseit.two_c_emotionalabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_d_violence':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_d_violence
                  if (this.cseit.two_d_violence === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'three_a_appearance':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_a_appearance
                  if (this.cseit.three_a_appearance === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_b_phystrauma':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_b_phystrauma
                  if (this.cseit.three_b_phystrauma === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_c_tattoo':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_c_tattoo
                  if (this.cseit.three_c_tattoo === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_d_pregsti':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_d_pregsti
                  if (this.cseit.three_d_pregsti === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_e_sleep':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_e_sleep
                  if (this.cseit.three_e_sleep === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_f_nutrition':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_f_nutrition
                  if (this.cseit.three_f_nutrition === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_g_sud':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_g_sud
                  if (this.cseit.three_g_sud === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_h_increasesud':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_h_increasesud
                  if (this.cseit.three_h_increasesud === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'four_a_risksex':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_a_risksex
                  if (this.cseit.four_a_risksex === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_b_location':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_b_location
                  if (this.cseit.four_b_location === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_c_language':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_c_language
                  if (this.cseit.four_c_language === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_d_association':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_d_association
                  if (this.cseit.four_d_association === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_e_bullied':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_e_bullied
                  if (this.cseit.four_e_bullied === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_f_jj':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_f_jj
                  if (this.cseit.four_f_jj === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_g_gang':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_g_gang
                  if (this.cseit.four_g_gang === 'No Information') { questionFourNoInformation++ }
                  break
                case 'five_a_unhealthyrel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_a_unhealthyrel
                  if (this.cseit.five_a_unhealthyrel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_b_onlinerel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_b_onlinerel
                  if (this.cseit.five_b_onlinerel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_c_photos':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_c_photos
                  if (this.cseit.five_c_photos === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_d_money':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_d_money
                  if (this.cseit.five_d_money === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_e_manyphones':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_e_manyphones
                  if (this.cseit.five_e_manyphones === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_f_travel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_f_travel
                  if (this.cseit.five_f_travel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'six_a_hypervigilant':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_a_hypervigilant
                  if (this.cseit.six_a_hypervigilant === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_b_cues':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_b_cues
                  if (this.cseit.six_b_cues === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_c_risktaking':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_c_risktaking
                  if (this.cseit.six_c_risktaking === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_d_celldistress':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_d_celldistress
                  if (this.cseit.six_d_celldistress === 'No Information') { questionSixNoInformation++ }
                  break
                case 'seven_a_abusive':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_a_abusive
                  if (this.cseit.seven_a_abusive === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_b_isolation':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_b_isolation
                  if (this.cseit.seven_b_isolation === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_c_pregnant':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_c_pregnant
                  if (this.cseit.seven_c_pregnant === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_d_coercion':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_d_coercion
                  if (this.cseit.seven_d_coercion === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_e_threats':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_e_threats
                  if (this.cseit.seven_e_threats === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_f_vague':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_f_vague
                  if (this.cseit.seven_f_vague === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'eight_a_exploited':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_a_exploited
                  if (this.cseit.eight_a_exploited === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_b_filmed':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_b_filmed
                  if (this.cseit.eight_b_filmed === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_c_history':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_c_history
                  if (this.cseit.eight_c_history === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_d_quota':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_d_quota
                  if (this.cseit.eight_d_quota === 'No Information') { questionEightNoInformation++ }
                  break
              }
            }

            i++
          }

          this.questionOneNoInformationPercentage = parseFloat(parseFloat(parseInt(questionOneNoInformation) / parseInt(questionOneTotal)) * 100).toFixed(2)
          this.questionTwoNoInformationPercentage = parseFloat(parseFloat(parseInt(questionTwoNoInformation) / parseInt(questionTwoTotal)) * 100).toFixed(2)
          this.questionThreeNoInformationPercentage = parseFloat(parseFloat(parseInt(questionThreeNoInformation) / parseInt(questionThreeTotal)) * 100).toFixed(2)
          this.questionFourNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFourNoInformation) / parseInt(questionFourTotal)) * 100).toFixed(2)
          this.questionFiveNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFiveNoInformation) / parseInt(questionFiveTotal)) * 100).toFixed(2)
          this.questionSixNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSixNoInformation) / parseInt(questionSixTotal)) * 100).toFixed(2)
          this.questionSevenNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSevenNoInformation) / parseInt(questionSevenTotal)) * 100).toFixed(2)
          this.questionEightNoInformationPercentage = parseFloat(parseFloat(parseInt(questionEightNoInformation) / parseInt(questionEightTotal)) * 100).toFixed(2)

          let cseitFirstPart = this.calculateSummaryNumber(this.cseit.calc_q1) + this.calculateSummaryNumber(this.cseit.calc_q2) + this.calculateSummaryNumber(this.cseit.calc_q3) + this.calculateSummaryNumber(this.cseit.calc_q4) + this.calculateSummaryNumber(this.cseit.calc_q5) + this.calculateSummaryNumber(this.cseit.calc_q6) + this.calculateSummaryNumber(this.cseit.calc_q7)

          let cseitSecondPart = 0

          if (this.cseit.calc_q8 === 'Possible Concern') {
            cseitSecondPart = 4
          } else if (this.cseit.calc_q8 === 'Clear Concern') {
            cseitSecondPart = 9
          }

          this.cseitFinalScore = cseitFirstPart + cseitSecondPart
        }
      },
      deep: true
    },
    orgPrograms: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        this.programs = clonedValue.map((program) => {
          var newTitle
          if (program.title === 'Other') {
            newTitle = program.title_otherText
          } else {
            newTitle = program.title
          }
          return {value: program.id, text: newTitle}
        })
      }
    },
    orgLocations: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        this.locations = clonedValue.map((location) => {
          return {value: location.id, text: location.title}
        })
      }
    }
  },
  created: function () {
    this.populateRecords()
  }
}
</script>

<style lang="scss">
  .cseit-table tr td {
    width: 60%;
  }

  .print-button-container {
	  margin: 20px 0 60px;
  }

  @media print {
    .app-body {
      display: block !important;
      margin: 0 !important;
    }

    .cseit-table {
      border-collapse: unset !important;
      display: inline-block !important;
    }

	  .print-button-container, .breadcrumb, .app-footer, .sidebar {
		  display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/PrintCseit.vue